/**
 * Created by zqy on 2018/8/20 0020.
 */
import Vue from 'vue'
import Vuex from 'vuex'

import app from './modules/app'
import content from './modules/content'
import ecommerce from './modules/ecommerce'
import errorLog from './modules/errorLog'
import permission from './modules/permission'
import user from './modules/user'
import tagsView from './modules/tagsView'
import cache from './modules/cache'
import getters from './getters'

Vue.use(Vuex)
const store = new Vuex.Store({
  modules: {
    app,
    errorLog,
    permission,
    content,
    ecommerce,
    user,
    tagsView,
    cache
  },
  getters
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js